/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../../base.model';
import { EquipmentRateDto } from './EquipmentRateDto';

export class EquipmentDto extends BaseModel {
  public VPCompanyID: number;
  public Name: string;
  public EquipmentIDs: string[];
  public DisplayName: string;
  public Order: number;
  // WI 32147: billing rates for this Bill As option (UnitName + BillingRate), populated
  // server-side by EquipmentRepository.GetEquipments. Shown under the option name in the
  // equipment-resource-dropdown. Optional: absent on client-built selections (e.g. the
  // Bill As / bulk-edit equipment set in equipment-dispatch-edit) and unpopulated for
  // rate-less options; all readers null-guard (`?? []`).
  public Rates?: EquipmentRateDto[];

  constructor(o: unknown = null) {
    super(o);
  }
}
